/**
 * Created by Ning Jiang on 2021-05-04.
 */
import {BlitzKriegParsedData} from "./BlitzKriegParsedData";
import {IBetWayWinData, IBetWinData, IBlitzKriegGameData, IFeatureData} from "./IBlitzKriegData";
import {BlitzKriegDataParser} from "./BlitzKriegDataParser";
import {IWinRatioConfig} from "../../../core/config/WinRatio";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {DDayGameConfig} from "../../DDayGameConfig";
import {StackedSymbol} from "../../../core/reel/stackedsymbol/StackedSymbol";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class BlitzKriegParsedGameData extends BlitzKriegParsedData {

    public readonly betWins: IBetWayWinData[];
    public readonly singleWin: number;
    public readonly playedBetValue: number;
    public readonly featureInfo: IFeatureData[];
    public readonly wasFeatureBuy: boolean;
    public readonly brokeTheBank: boolean;
    public readonly symbolSizes: number[][];
    public totalWays: number;
    public readonly currentWinRatioConfig: IWinRatioConfig | null;
    public readonly nearWinReels: boolean[];


    constructor(rawData: IBlitzKriegGameData, parser: BlitzKriegDataParser) {
        super(rawData, parser);

        this.betWins = parser.parseBetWins(rawData);
        this.singleWin = rawData.totalSpinWinnings;
        this.playedBetValue = rawData.playedBetValue;
        this.wasFeatureBuy = rawData.wasFeatureBuy;
        this.brokeTheBank = rawData.brokeTheBank;
        this.featureInfo = rawData.featureInfo;
        this.symbolSizes = rawData.symbolSizes;
        // Calculated values.
        this.currentWinRatioConfig = parser.parseWinRatio(this.singleWin / this.playedBetValue);

        // To add Spin Data
        this.nearWinReels = parser.parseNearWinReels(this.scatterPositions, this.wasFeatureBuy);
        this.totalWays = 0;
        this.betWins.forEach((betWin) => {
            this.totalWays = this.totalWays + betWin.numberOfCombinations;
            betWin.reelWinPositions = this.calculateReelWinPos(rawData, betWin.symbol);
        });
    }

    private calculateReelWinPos(rawData: IBlitzKriegGameData, symbol: string): boolean[][] {
        const reelWinPos: boolean[][] = ArrayHelper.initArrayWithValues<boolean[]>(DDayGameConfig.REELS_NUM, (index: number) => {
            return ArrayHelper.initArrayWithValues<boolean>(rawData.evaluatedArea[index].length, () => false);
        });
        let connectedReel: boolean = false;
        for (let reelId: number = 0; reelId < rawData.evaluatedArea.length; reelId++) {
            connectedReel = false;
            for (let symId: number = 0; symId < rawData.evaluatedArea[reelId].length; symId++) {
                if (rawData.evaluatedArea[reelId][symId] === symbol || rawData.evaluatedArea[reelId][symId] === "W") {
                    reelWinPos[reelId][symId] = true;
                    connectedReel = true;
                }
            }
            if (!connectedReel) {
                break;
            }
        }
        return reelWinPos;
    }

    private getRandomBigWinTease(): boolean {
        if (this.wasFeatureBuy) {
            return false;
        }
        if (this.totalWin === 0 || (this.currentWinRatioConfig && (this.currentWinRatioConfig?.ratio < DDayGameConfig.WIN_RATIOS[3].ratio))) {
            return false;
        }
        switch (this.mode) {
            case GameMode.NORMAL:
                return this.currentWinRatioConfig!.ratio + Math.random() * 15 > 35;
            case GameMode.FREESPIN:
                return this.currentWinRatioConfig!.ratio + Math.random() * 20 > 50;
            // case SerialGameMode.FREESPIN_SUPER:
            //     return false; // super fs reel 5 stop the first!
            default:
                return false;
        }
    }
}
